export const translations = {
  en: {
    appTitle: "LoadWise",
    appSubtitle: "Smarter Loads. Bigger Profits.",
    langToggle: "عربي",

    // Sections
    loadInfo: "Load Information",
    costSettings: "Cost Settings",
    milesSummary: "Miles Summary",
    profitAnalysis: "Profitability Analysis",
    loadDecision: "Load Decision",
    history: "Saved Loads",
    compare: "Compare Loads",

    // Fields
    pickCity: "Pick City",
    deliveryCity: "Delivery City",
    loadedMiles: "Loaded Miles",
    emptyMiles: "Empty Miles",
    pickupTime: "Pickup Time",
    deliveryTime: "Delivery Time",
    weight: "Weight (lbs)",
    commodity: "Commodity",
    rate: "Rate ($)",
    costPerMile: "Cost Per Mile ($)",
    driverPayPerMile: "Driver Pay Per Mile ($)",
    dispatcherFee: "Dispatcher Fee (%)",
    minProfit: "Minimum Profit Goal ($)",

    // KPIs
    totalMiles: "Total Miles",
    realRPM: "Real RPM",
    totalRate: "Total Rate",
    tripCost: "Trip Cost",
    driverPay: "Driver Pay",
    dispatcherFeeAmt: "Dispatcher Fee",
    netProfit: "Net Profit",
    profitPerMile: "Profit / Mile",

    // Decision
    profitable: "PROFITABLE LOAD",
    notProfitable: "NOT PROFITABLE",
    profitableSub: "Net profit exceeds your minimum goal",
    notProfitableSub: "Net profit is below your minimum goal",

    // Actions
    saveLoad: "Save Load",
    exportPdf: "Export PDF",
    resetDefaults: "Reset to Defaults",
    clearAll: "Clear All",
    delete: "Delete",
    view: "View",
    selectToCompare: "Select two loads to compare",
    compareSelected: "Compare Selected",
    closeCompare: "Close",

    // Toasts
    savedSuccess: "Load saved successfully",
    saveFailed: "Failed to save load",
    deleteSuccess: "Load deleted",
    deleteFailed: "Failed to delete load",
    exportSuccess: "PDF exported successfully",
    selectExactlyTwo: "Please select exactly 2 loads to compare",
    noHistory: "No saved loads yet. Save your first load to see it here.",

    route: "Route",
    date: "Date",
    status: "Status",
    actions: "Actions",
  },
  ar: {
    appTitle: "LoadWise",
    appSubtitle: "أحمال أذكى. أرباح أكبر.",
    langToggle: "English",

    loadInfo: "معلومات الحمولة",
    costSettings: "إعدادات التكلفة",
    milesSummary: "ملخص الأميال",
    profitAnalysis: "تحليل الربحية",
    loadDecision: "قرار الحمولة",
    history: "الحمولات المحفوظة",
    compare: "مقارنة الحمولات",

    pickCity: "مدينة التحميل",
    deliveryCity: "مدينة التسليم",
    loadedMiles: "الأميال المحملة",
    emptyMiles: "الأميال الفارغة",
    pickupTime: "وقت التحميل",
    deliveryTime: "وقت التسليم",
    weight: "الوزن (رطل)",
    commodity: "نوع الحمولة",
    rate: "السعر الإجمالي ($)",
    costPerMile: "تكلفة التشغيل لكل ميل ($)",
    driverPayPerMile: "أجر السائق لكل ميل ($)",
    dispatcherFee: "عمولة الديسباتشر (%)",
    minProfit: "الحد الأدنى للربح ($)",

    totalMiles: "إجمالي الأميال",
    realRPM: "السعر الحقيقي للميل",
    totalRate: "إجمالي السعر",
    tripCost: "تكلفة الرحلة",
    driverPay: "أجر السائق",
    dispatcherFeeAmt: "عمولة الديسباتشر",
    netProfit: "صافي الربح",
    profitPerMile: "الربح لكل ميل",

    profitable: "حمولة مربحة",
    notProfitable: "غير مربحة",
    profitableSub: "صافي الربح يتجاوز الحد الأدنى المطلوب",
    notProfitableSub: "صافي الربح أقل من الحد الأدنى المطلوب",

    saveLoad: "حفظ الحمولة",
    exportPdf: "تصدير PDF",
    resetDefaults: "استعادة الافتراضيات",
    clearAll: "حذف الكل",
    delete: "حذف",
    view: "عرض",
    selectToCompare: "اختر حمولتين للمقارنة",
    compareSelected: "قارن المحدد",
    closeCompare: "إغلاق",

    savedSuccess: "تم حفظ الحمولة بنجاح",
    saveFailed: "فشل حفظ الحمولة",
    deleteSuccess: "تم حذف الحمولة",
    deleteFailed: "فشل حذف الحمولة",
    exportSuccess: "تم تصدير PDF بنجاح",
    selectExactlyTwo: "الرجاء اختيار حمولتين بالضبط للمقارنة",
    noHistory: "لا توجد حمولات محفوظة حتى الآن. احفظ أول حمولة لتظهر هنا.",

    route: "المسار",
    date: "التاريخ",
    status: "الحالة",
    actions: "الإجراءات",
  },
};

export const useT = (lang) => (key) => translations[lang]?.[key] ?? key;
